import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["preview"];
  
  updatePreview(event) {
    const selectedValue = event.target.value;
    const previewText = window.verbiageTexts[selectedValue];
    this.previewTarget.innerHTML = previewText ? `Selected verbiage: ${previewText}` : "No verbiage selected";
  }
}
